import axios from 'axios';
import Pagination from '../component/paginations/pagination';

const ContactApi = {};

const nonce = devsAccountingApi.nonce;


// Pagination

// ContactApi.index = async (params = null) => {
//     const url = '/wp-json/devs-accounting/v1/contacts/';
//     try {
//         const response = await axios.get(url, { params: params });
//         return {
//             data: response.data.data || [], // Items list
//             total_contact: response.data.total_contact || 0, // Total items count
//             total_pages: response.data.total_pages || 1, // Total number of pages
//             current_page: response.data.current_page || 1, // Current page number
//         };
//     } catch (error) {
//         console.error(error);
//         return {
//             data: [],
//             total_contact: 0,
//             total_pages: 0,
//             current_page: 1,
//         };
//     }
// };

ContactApi.index = async (params = { page: 1, per_page: 10 }) => {
    const url = '/wp-json/devs-accounting/v1/contacts/';
    try {
        // Ensure params is a valid object
        params = params || { page: 1, per_page: 10 };

        const response = await axios.get(url, { params });

        return {
            data: response.data.data || [], // Items list
            total_contact: response.data.total_contact || 0, // Total items count
            total_pages: response.data.total_pages || 1, // Total number of pages
            current_page: response.data.current_page || 1, // Current page number
        };
    } catch (error) {
        console.error('Error fetching contacts:', error);

        return {
            data: [],
            total_contact: 0,
            total_pages: 0,
            current_page: 1,
            error: error.message || 'Failed to fetch contacts.',
        };
    }
};


ContactApi.show = async (id, params = null) => {
    const url = '/wp-json/devs-accounting/v1/get-contact/' + id;
    try {
        const response = await axios.get(url, { params: params });
        return response.data;
    } catch (error) {
        console.error(error);
        return [];
    }
};

ContactApi.delete = async (id, params = null) => {
    const url = '/wp-json/devs-accounting/v1/delete-contact/' + id;
    try {
        const response = await axios.get(url, {
            headers: {
                'X-WP-Nonce': nonce
            }
        });
        return response.data;
    } catch (error) {
        console.error(error);
        return [];
    }
};

ContactApi.save = async (data) => {
    let url = "/wp-json/devs-accounting/v1/add-contact/";
    const res = await axios.post(url, data, {
        headers: {
            'X-WP-Nonce': nonce
        }
    }).then(response => {
        return response.data;
    }).catch(error => { return error.response.data; });
    return res;
}

export default ContactApi;